import React, { useState, useEffect } from 'react';
import { BookOpenIcon } from 'lucide-react';
import { useAuth } from '@clerk/clerk-react';
import { api_endpoint } from '@/constants/constant';
import { EmptyState } from '@/components/emptyState';
import axios from 'axios';
import { Spinner } from '@/components/spinner';
import TopicCard from '@/components/topicCard';


export default function ContentTab({ course, topics, loading, error, refetchTopics }) {

    if (!course?.id) {
    return (
      <EmptyState
        icon={BookOpenIcon}
        title="No Course Selected"
        description="Please select a course to view content."
      />
    );
  }

    if (loading || topics === null) {
    return (
      <EmptyState
        title={<Spinner />}
        description="Please wait while we load the topics for this course."
      />
    );
  }

    if (error) {
        return (
            <EmptyState
                icon={BookOpenIcon}
                title="Error Loading Topics"
                description={error}
            />
        );
    }

    if (topics?.length === 0) {
        return (
            <EmptyState
                icon={BookOpenIcon}
                title="No Topics"
                description="No topics available for this course yet."
            />
        );
    }

    return (
        <>
            <div className="space-y-8">
                {topics?.map(topic => (
                    <TopicCard
                        key={topic.id}
                        topic={topic}
                        refetchTopics={refetchTopics}
                        course={course}
                    />
                ))}
            </div>
        </>
    )



}
